/**
 * RS Go plateform v1.0.0 - React APPLICATION
 * Copyright 2017-present, My Edition Company SAS -> for RoyalSpeed SARL
 * All rights reserved.
 *
 * @authors: José Barcelon Godfrey
 * Paris, France
 */

import React, {Component, PropTypes} from 'react'
import f_options from './_foptions.jsx'
import ReactTooltip from 'react-tooltip'
import Phone from 'react-phone-number-input'

export default class PersonalInformation extends Component {

 constructor(props){
   super(props);
   this.handleDataChange = this.handleDataChange.bind(this)
   this.validationForm = this.validationForm.bind(this)
   this.state = {
     prospect_gender: this.props.fieldValues.prospect_gender,
     prospect_firstname: this.props.fieldValues.prospect_firstname,
     prospect_lastname: this.props.fieldValues.prospect_lastname,
     prospect_email: this.props.fieldValues.prospect_email,
     prospect_phone: this.props.fieldValues.prospect_phone,
     promo_code: this.props.fieldValues.promo_code,
     valid_phone: null,
     valid_mail: null
   }
 }
 handleDataChange(phone){
   if(phone === undefined){
     phone = null
   }

   var gender = this.refs.gender.value,
       firstName = this.refs.firstName.value,
       lastName = this.refs.lastName.value,
       email = this.refs.email.value,
       promo_code = this.refs.promo_code.value

   this.setState({
     prospect_gender: gender,
     prospect_firstname: firstName,
     prospect_lastname: lastName,
     prospect_email: email,
     prospect_phone: phone,
     promo_code: promo_code
   })

   var data = {
     prospect_gender: gender,
     prospect_firstname: firstName,
     prospect_lastname: lastName,
     prospect_email: email,
     prospect_phone: phone,
     promo_code: promo_code
   }
   this.props.saveValues(data)
 }
 validationForm(){
   var that = this

   function isEmail(email){
     var regex = /^([0-9a-zA-Z]([-_\\.]*[0-9a-zA-Z]+)*)@([0-9a-zA-Z]([-_\\.]*[0-9a-zA-Z]+)*)[\\.]([a-zA-Z]{2,9})$/
     if(!regex.test(email)){
       return false
     }else{
       return true
     }
   }
   if(isEmail(this.state.prospect_email)){
     if(Number.isInteger(parseFloat(this.state.prospect_phone))){
       if(this.state.prospect_firstname !== null && this.state.prospect_firstname !== "" &&
         this.state.prospect_lastname !== null && this.state.prospect_lastname !== "" &&
         this.state.prospect_email !== null && this.state.prospect_email !== "" &&
         this.state.prospect_phone !== null && this.state.prospect_phone.length >= 10){
         return true
       }else{
         return false
       }
     }else{
       return false
     }
   }else{
     return false
   }
 }
 render() {
   console.log(this.state.prospect_phone)
   var obj = this.props.fieldValues
   var validForm = this.validationForm()
   var selectedOption = this.props.f <= 3 ? f_options.main["_fopt"+this.props.f] : f_options.other["_fopt"+this.props.f]
   var btnSubmit
   validForm == true ? btnSubmit = <button className="go-button go-green pull-right" onClick={this.props.sendForm}>Envoyer <span className="rs-icon-check"></span></button> : btnSubmit = <button data-tip="Veuillez remplir les champs obligatoires." data-class="tooltip-info" className="go-button go-green pull-right disabled">Envoyer <span className="rs-icon-check"></span></button>

   return <div className="go-form-step">
           <div className="go-step-header">
             <button className="go-button go-green pull-left" onClick={() => {this.props.prev(3)}}><span className="rs-icon-angle-left"></span>Etape précédente</button>
             {btnSubmit}
             <h1 className='center-text'>3. Quelques informations vous concernant ?</h1>
           </div>
           <div className="row">
             <div className="four columns">
               <div className="go-card formation-option smaller">
                 <div className={"option-graphic "+selectedOption.icon}>
                 </div>
                 <div>
                   <p>Formation choisie :</p>
                   <h2>{selectedOption.name}</h2>
                   <div>
                     {/*{Object.keys(obj).map(function(key, index) {*/}
                       {/*return <div>{obj[key]}</div>*/}
                     {/*})}*/}
                   </div>
                 </div>
               </div>
             </div>
             <div className="eight columns">
               <div className="row info-form">
                 <p>Dernière étape de votre inscription 😉</p>
               </div>
               <div className="container-toggle-form">
                 <div className="row toggle-form">
                  <div className="two columns">
                    <label htmlFor="gender">Civilité<span className="reqField">*</span></label>
                     
                    <select name="gender" ref="gender" id="gender">
                      <option value="0">Mr</option>
                      <option value="1">Mme/Mlle</option>  
                    </select>
                  </div>
                   <div className="five columns">
                     <label htmlFor="lastName">Nom<span className="reqField">*</span></label>
                     <input type="text"
                            id="lastName"
                            className="full-width"
                            ref="lastName"
                            maxLength="40"
                            defaultValue={this.props.fieldValues.prospect_lastname === null ? "" : this.props.fieldValues.prospect_lastname}
                            onChange={() => {this.handleDataChange()}}/>
                   </div>
                   <div className="five columns">
                     <label htmlFor="firstName">Prénom<span className="reqField">*</span></label>
                     <input type="text"
                            id="firstName"
                            className="full-width"
                            ref="firstName"
                            maxLength="40"
                            defaultValue={this.props.fieldValues.prospect_firstname === null ? "" : this.props.fieldValues.prospect_firstname}
                            onChange={() => {this.handleDataChange()}}/>
                   </div>
                 </div>
                 <div className="row toggle-form">
                   <label htmlFor="email">Email<span className="reqField">*</span></label>
                   <input type="email"
                          id="email"
                          className="full-width"
                          ref="email"
                          defaultValue={this.state.prospect_email === null ? "" : this.state.prospect_email}
                          onChange={() => {this.handleDataChange()}}/>
                   {/*{validInfo}*/}
                 </div>
                 <div className="row toggle-form">
                   <label htmlFor="phone">Téléphone<span className="reqField">*</span></label>
                   <Phone
                     placeholder="Saisissez votre numero de téléphone"
                     value={ this.state.prospect_phone === null ? "" : this.state.prospect_phone }
                     onChange={ phone => {this.handleDataChange(phone)} }
                     country="FR"
                     countries={['FR', 'BE', 'ES','DE', 'GB','MC', 'RU', 'SE', 'CH', 'US']}/>

                 </div>
                 <div className="row toggle-form">
                   <label htmlFor="email">Code Promo</label>
                   <input type="text"
                          id="promo_code"
                          className="full-width"
                          ref="promo_code"
                          defaultValue={this.state.promo_code === null ? "" : this.state.promo_code}
                          onChange={() => {this.handleDataChange()}}/>
                 </div>
                 <div className="row toggle-form info">
                   <p><span className="reqField">*</span>Champs obligatoires</p>
                 </div>
               </div>
              {btnSubmit}
              <ReactTooltip effect="solid"/>
           </div>
         </div>
        </div>
 }

}


// WEBPACK FOOTER //
// ./go/views/components/signup/personnel.jsx